import SequenceButton from "../Button/SequenceButton";

const PageTitle = ({
  title,
  showFilter,
  addButton,
  buttonText,
  buttonFunction,
  socondaryButton,
  secondarybuttonText,
  secondarybuttonFunction,
  sequenceButton,
  sequenceButtonProps,
  // Billing cycle toggle props
  billingCycleToggle,
  billingCycleValue,
  billingCycleEnabled,
  onBillingCycleChange,
}) => {
  return (
    <div className="sticky top-16 lg:top-0 z-30 bg-white p-5 border-b border-gray-200 shadow-sm">
      <div className="mx-auto w-full">
        <div className="md:flex md:items-center md:justify-between">
          <div className="min-w-0 flex-1">
            <h2 className="text-2xl font-bold leading-7 text-gray-900 py-1 sm:truncate sm:text-3xl sm:tracking-tight">
              {title}
            </h2>
          </div>
          {showFilter && (
            <div className="mt-4 flex md:ml-4 md:mt-0">
              <button
                type="button"
                className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                Date filter
              </button>
              <button
                type="button"
                className="ml-3 inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
              >
                Branch Filter
              </button>
            </div>
          )}
          <div className="flex max-md:gap-4 items-center">
            {addButton && buttonText && (
              <div className="mt-4 flex md:ml-4 md:mt-0">
                <button
                  type="button"
                  className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  onClick={buttonFunction}
                >
                  {buttonText ?? "New"}
                </button>
              </div>
            )}
            {socondaryButton && secondarybuttonText && (
              <div className="mt-4 flex md:ml-4 md:mt-0">
                <button
                  type="button"
                  className="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                  onClick={secondarybuttonFunction}
                >
                  {secondarybuttonText}
                </button>
              </div>
            )}

            {/* Billing Cycle Toggle — shown only on reservation detail pages */}
            {billingCycleToggle && (
              <>
                {/* Separator */}
                <div className="mt-4 md:ml-4 md:mt-0 h-8 w-px bg-gray-300"></div>
                <div className="mt-4 flex md:ml-4 md:mt-0 items-center gap-2">
                  <span
                    className={`text-sm font-medium select-none ${
                      billingCycleEnabled ? "text-gray-700" : "text-gray-400"
                    }`}
                  >
                    Billing cycle
                  </span>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={!!billingCycleValue}
                    disabled={!billingCycleEnabled}
                    onClick={() => {
                      if (billingCycleEnabled && typeof onBillingCycleChange === "function") {
                        onBillingCycleChange(!billingCycleValue);
                      }
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                      billingCycleValue
                        ? "bg-indigo-600"
                        : "bg-gray-200"
                    } ${
                      !billingCycleEnabled
                        ? "opacity-40 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                        billingCycleValue ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>
              </>
            )}

            {sequenceButton && sequenceButtonProps && (
              <>
                {/* Separator */}
                <div className="mt-4 md:ml-4 md:mt-0 h-8 w-px bg-gray-300"></div>
                {/* Sequence Button */}
                <div className="mt-4 flex md:ml-4 md:mt-0">
                  <SequenceButton {...sequenceButtonProps} />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
